import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { FormDetailsComponentData } from "../../form-details.model";
import { TriggersService } from "./services/triggers.service";
import { OwnerInfoDetailsService } from "./services/owner-info-details.service";
import { SharedDetailsService } from "./services/shared-details.service";
import { DocumentsDetailsService } from "./services/documents-details.service";
import { BrokerStatus } from "@partner/shared/SharedConstants";
import { ApplicationData } from "../../../../../../domain/models/application.model";

@Injectable()
export class FormDetailsBaseViewFacade {
  constructor(
    private readonly triggersService: TriggersService,
    private readonly ownerService: OwnerInfoDetailsService,
    private readonly sharedService: SharedDetailsService,
    private readonly documentsService: DocumentsDetailsService,
  ) { }

  initAutosaveData(initialData: FormDetailsComponentData): void {
    this.sharedService.initAutosaveData(initialData);
  }

  handleBeforeUnloadAction(event: BeforeUnloadEvent, submissionForm: FormGroup): void {
    return this.triggersService.handleBeforeUnloadAction(event, submissionForm);
  }

  initActions(submissionForm: FormGroup, application: ApplicationData): void {
    this.ownerService.initOwnersActions(submissionForm, application);
    this.documentsService.initDocumentsActions(application);
    this.sharedService.initAutosaveActions();
  }

  initTriggers(submissionForm: FormGroup, abortController: AbortController): void {
    this.triggersService.initTriggers(submissionForm, abortController);
  }

  expandAllSectionsIfIncomplete(brokerStatus: BrokerStatus): void {
    this.sharedService.expandAllSectionsIfIncomplete(brokerStatus);
  }
}
